import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ButtonModule } from './../button/button.module';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SnackbarComponent } from './snackbar.component';

@NgModule({
  imports: [CommonModule, MatSnackBarModule, MatIconModule, ButtonModule],
  declarations: [SnackbarComponent],
  exports: [SnackbarComponent],
})
export class SnackbarModule {}
